<template>
<!-- todo add in title belt record and ability to hover and see score of each title belt match. -->
<div class="row">
  <div class="col-7 col-sm-6 col-md-5 col-lg-4" v-if="titleBelt.longestStreak && titleBelt.longestStreak.count > 0">
    <div class="row">
      <div class="col-12">Longest Streak: {{titleBelt.longestStreak.count}}</div>
      <div v-for="holder in titleBelt.longestStreak.owners" :key="holder.owner.id" class="offset-1 col-11 text--bold">
        {{holder.owner.firstName}} {{holder.owner.lastName}}    
      </div>
    </div>
    <div class="row">
      <div class="col-10 text--secondary">
        Name
      </div>
      <div class="col-2 text--secondary">
        #
      </div>
    </div>
    <div v-for="(holder) in titleBelt.winners" :key="holder.owner.id" class="row" style="text-align: left;">
      <div class="col-10">
        <div class="row">
          <div class="col-12 col-lg-7">
            {{holder.owner.firstName}} {{holder.owner.lastName}}
          </div>
          <div class="col-12 col-lg-5 text--secondary" style="font-size:12px;">
            ({{holder.season}} - {{holder.week}})
          </div>
        </div>
      </div>
      <div class="col-2 col-lg-2">{{holder.count}}</div>
    </div>
  </div>
  <div v-if="titleBeltHistory && titleBeltHistory.length > 0" class="offset-1 col-4 offset-sm-0 col-sm-6 col-md-7 col-lg-8">
    <h6>History</h6>
    <div class="row">
      <div v-for="(holder, index) in titleBeltHistory" :key="index" class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2" style="text-align: left;">
        <div :class="['row', index === 0 ? 'text--bold' : '']">
          {{holder.owner.firstName}} {{holder.owner.lastName}}
        </div>
        <div class="row text--secondary" style="font-size: 12px; margin-bottom: 8px; margin-top: -3px;">
          {{holder.season}} Week {{holder.week}}
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    Loading or broken
  </div>
</div>
</template>

<script lang="ts">
import Matchup from "@/shared/matchups/matchup";
import Owner from "@/shared/owners/owner";
import OwnerTeam from "@/shared/teams/owner-team";
import TitleBeltHolder from '@/shared/title-belts/title-belt-holder';
import TitleBelt, { WinnersDictionary } from '@/shared/title-belts/title-belt';
import { ref } from "vue";
import Season from "@/shared/seasons/season";
import Team from "@/shared/teams/team";
import { useRouter } from "vue-router";
import { orderBy } from 'lodash';
import { useStore } from 'vuex';
import { watch } from 'vue';
function getTitleBeltHistory(seasons: Season[]) {
  const ownerTeams: OwnerTeam[] = [];
  const titleBeltHistory: TitleBeltHolder[] = [];
  let memberCount = 1;

  function getOwnerTeam(ownerTeams: OwnerTeam[], id: number, season: number): OwnerTeam {
    const baseOwnerTeam: OwnerTeam = {
      id: 0,
      owner: {
        id: "0",
        firstName: "BYE",
        lastName: "WEEK",
      },
      teams: [],
      teamYears: [],
      experience: 0,
    };

    if (id === 0) {
      return baseOwnerTeam;
    }

    for (let i = 0; i < ownerTeams.length; i++) {
      const ownerTeam: OwnerTeam = ownerTeams[i];
      const teamYear = ownerTeam.teamYears && ownerTeam.teamYears.find((teamYear) => {
        return teamYear.year === season && teamYear.team === id;
      });

      if (teamYear) return ownerTeam;
    }

    return baseOwnerTeam;
  }

  function isOwnerInMatchup(ownerTeam: TitleBeltHolder, matchup: Matchup, seasonId: number, teamSide: 'home' | 'away') {
    if (!ownerTeam) return false;
    return ownerTeam.teamYears && ownerTeam.teamYears.some(
      (teamYear) =>
        teamYear.year === seasonId &&
        matchup[teamSide] &&
        teamYear.team === matchup[teamSide].teamId
    );
  }

  function isOwnerInSeason(ownerTeam: TitleBeltHolder, seasonId: number) {
    if (!ownerTeam) return false;
    return ownerTeam.teamYears && ownerTeam.teamYears.some(
      (teamYear) =>
        teamYear.year === seasonId
    );
  }


  function getMatchupScores(
    matchup: Matchup,
    teamSide: 'home' | 'away',
    season: Season
  ) {
    if (matchup.winner === teamSide.toUpperCase() || matchup.winner === 'TIE') {
      const currentTeam: OwnerTeam = getOwnerTeam(ownerTeams, matchup[teamSide].teamId, season.seasonId);
      const titleBeltHolder: TitleBeltHolder = { ...currentTeam, week: matchup.matchupPeriodId, season: season.seasonId, count: 1 }
      titleBeltHistory.push(titleBeltHolder);
    } else if (matchup.winner !== "UNDECIDED") {
      if (teamSide === 'home') {
        const currentTeam: OwnerTeam = getOwnerTeam(ownerTeams, matchup['away'].teamId, season.seasonId);
        const titleBeltHolder: TitleBeltHolder = { ...currentTeam, week: matchup.matchupPeriodId, season: season.seasonId, count: 1 }
        titleBeltHistory.push(titleBeltHolder);
      } else { 
        const currentTeam: OwnerTeam = getOwnerTeam(ownerTeams, matchup['home'].teamId, season.seasonId);
        const titleBeltHolder: TitleBeltHolder = { ...currentTeam, week: matchup.matchupPeriodId, season: season.seasonId, count: 1 }
        titleBeltHistory.push(titleBeltHolder); 
      }
    }
  }

  function getHighestScorerForWeek(season: Season, week: number): TitleBeltHolder {
    let weeklyHighScore = 0;
    let weeklyHighScorer: TitleBeltHolder = {
      week: week,
      season: season.seasonId,
      count: 1,
      owner: {
        firstName: 'default',
        lastName: 'name',
      }
    };

    for (let i = 0; i < season.schedule.length; i++) {
      const matchup: Matchup = season.schedule[i];
      if (matchup.matchupPeriodId !== week) {
        continue;
      }

      if (matchup.home.totalPoints > weeklyHighScore) {
        weeklyHighScore = matchup.home.totalPoints;
        weeklyHighScorer = { ...getOwnerTeam(ownerTeams, matchup.home.teamId, season.seasonId), week: week, season: season.seasonId, count: 1 };
      }

      if (matchup.away.totalPoints > weeklyHighScore) {
        weeklyHighScore = matchup.away.totalPoints;
        weeklyHighScorer = { ...getOwnerTeam(ownerTeams, matchup.away.teamId, season.seasonId), week: week, season: season.seasonId, count: 1 };
      }
    }

    return weeklyHighScorer;
  }

  for (let i = 0; i < seasons.length; i++) {
    const season = seasons[i];

    for (let k = 0; k < season.members.length; k++) {
      const member: Owner = season.members[k];

      if (!ownerTeams.some((x) => x.owner && x.owner.id === member.id)) {
        memberCount++;
        const ownerTeam: OwnerTeam = {
          id: memberCount,
          currentSeasonGames: {
            pointsFor: 0,
            pointsAgainst: 0,
            wins: 0,
            losses: 0,
            ties: 0,
            matchupCount: 0,
          },
          recentGames: {
            pointsFor: 0,
            pointsAgainst: 0,
            wins: 0,
            losses: 0,
            ties: 0,
            matchupCount: 0,
          },
          matchupHistory: [],
          owner: member,
          teams: [],
          teamYears: [],
          highScore: {
            points: 0,
          },
          lowScore: {
            points: 500,
          },
          championshipYears: [],
          playoffYears: [],
          playoffWins: 0,
          experience: 0,
        };
        ownerTeams.push(ownerTeam);
      }
    }
  }

  for (let i = 0; i < seasons.length; i++) {
    const season: Season = seasons[i];

    for (let j = 0; j < season.teams.length; j++) {
      const team: Team = season.teams[j];

      for (let i = 0; i < ownerTeams.length; i++) {
        const ownerTeam: OwnerTeam = ownerTeams[i];
        if (ownerTeam.owner && team.owners && ownerTeam.owner.id === team.owners[0] && ownerTeam.teams && ownerTeam.teamYears) {
          ownerTeam.teams.push(team);
          if (team.id) {
            ownerTeam.teamYears.push({ year: season.seasonId, team: team.id });
          }
        }
      }
    }

    if (i === 0) {
      for (let index = season.schedule.length - 1; index > 0; index--) {
        const matchup: Matchup = season.schedule[index];
        if (matchup.playoffTierType === 'WINNERS_BRACKET') {
          if (matchup.winner === 'AWAY') {
            const currentTeam: OwnerTeam = getOwnerTeam(ownerTeams, matchup['away'].teamId, season.seasonId);

            const titleBeltHolder: TitleBeltHolder = { ...currentTeam, week: matchup.matchupPeriodId, season: season.seasonId, count: 1 }
            titleBeltHistory.push(titleBeltHolder);
          } else if (matchup.winner === 'HOME') {
            const currentTeam: OwnerTeam = getOwnerTeam(ownerTeams, matchup['home'].teamId, season.seasonId);
            const titleBeltHolder: TitleBeltHolder = { ...currentTeam, week: matchup.matchupPeriodId, season: season.seasonId, count: 1 }
            titleBeltHistory.push(titleBeltHolder)
          }

          break;
        }
      }
    } else {  
      let needsNewTitleBeltHolder = false;
      let newTitleBeltHolderAdded = false;
      if (!isOwnerInSeason(titleBeltHistory[titleBeltHistory.length - 1], season.seasonId)) {
        needsNewTitleBeltHolder = true;
      }

      for (let matchupIndex = 0; matchupIndex < season.schedule.length; matchupIndex++) {
        const matchup: Matchup = season.schedule[matchupIndex];

        if (needsNewTitleBeltHolder && matchup.matchupPeriodId === 1) {
          if (!newTitleBeltHolderAdded) {
            const newBeltHolder: TitleBeltHolder = getHighestScorerForWeek(season, matchup.matchupPeriodId);
            titleBeltHistory.push(newBeltHolder);
            newTitleBeltHolderAdded = true;
          }
          continue;
        } else if (needsNewTitleBeltHolder && matchup.matchupPeriodId !== 1) {
          needsNewTitleBeltHolder = false;
          newTitleBeltHolderAdded = false;
        }

        if (isOwnerInMatchup(titleBeltHistory[titleBeltHistory.length - 1], matchup, season.seasonId, "away")) {
          getMatchupScores(matchup, "away", season);
        } else if (isOwnerInMatchup(titleBeltHistory[titleBeltHistory.length - 1], matchup, season.seasonId, "home")) { 
          getMatchupScores(matchup, "home", season);
        }
      }
    }
  }

  return titleBeltHistory.reverse();
}

function gettitleBelt(titleBeltHolders: TitleBeltHolder[]): TitleBelt {
  const titleBelt: TitleBelt = {
    longestStreak: {
      owners: [],
      count: 0,
    },
    winners: []
  }

  const winners: WinnersDictionary = {};

  let currentStreak = 0;
  for (let i = 0; i < titleBeltHolders.length; i++) {
    const winner: TitleBeltHolder = titleBeltHolders[i];

    if (i === 0) {
      titleBelt.longestStreak.owners.push(winner);
      currentStreak++;
      titleBelt.longestStreak.count = currentStreak;
    } else {
      const previousHolder = titleBeltHolders[i-1];
      if (winner.owner && previousHolder && previousHolder.owner && winner.owner.id === previousHolder.owner.id) {
        currentStreak++;
        
        if (currentStreak > titleBelt.longestStreak.count) {
          titleBelt.longestStreak.owners = [];
          titleBelt.longestStreak.owners.push(winner);
          titleBelt.longestStreak.count = currentStreak;
        } else if (currentStreak === titleBelt.longestStreak.count) {
          titleBelt.longestStreak.owners.push(winner);
        } 
      } else {
        currentStreak = 1;
      }
    }

    const winnerProfile = winner.owner && winner.owner.id && winners[winner.owner.id];

    if (winnerProfile) {
      winnerProfile.count++;
    } else if (winner.owner && winner.owner.id) {
      winners[winner.owner.id] = {
        owner: winner.owner,
        count: 1,
        week: winner.week,
        season: winner.season,
      }
    }
  }

  titleBelt.winners = orderBy(winners, ["count"], ["desc"]);

  return titleBelt;
}

function useHistory() {
  const selectedTeam = ref<Team>();
  const titleBeltHistory = ref<Array<TitleBeltHolder>>();
  const titleBelt = ref({});
  const router = useRouter();
  const store = useStore();

  async function getLeagueHistory() {
    titleBeltHistory.value = getTitleBeltHistory(store.state.league);
    titleBelt.value = gettitleBelt(titleBeltHistory.value);
  }

  watch(
    () => store.state.leagueId, 
    () => {
      titleBeltHistory.value = [];
      titleBelt.value = {};
      getLeagueHistory();
    }
  )

  watch(
    () => store.state.league, 
    () => {
      titleBeltHistory.value = [];
      titleBelt.value = {};
      getLeagueHistory();
    }
  )

  getLeagueHistory();

  return { router, selectedTeam, titleBeltHistory, titleBelt };
}

export default {
  setup() {
    return useHistory();
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";
.table__header {
  color: $color-secondary-text;
}
</style>